import { FC } from 'react';
import { PlanResponse, PlanUsageResponse } from '@/shared/api';
import { EnterprisePlan } from './EnterprisePlan';
import { FreePlan } from './FreePlan';
import { ProPlan } from './ProPlan';

type Props = { isActive?: boolean } & (PlanResponse | PlanUsageResponse);

const renderPlan = (
  data: PlanResponse & PlanUsageResponse,
  isActive: boolean,
) => {
  switch (data.type) {
    case 'Free':
      return <FreePlan {...data} isActive={isActive} />;

    case 'Pro':
      return <ProPlan {...data} isActive={isActive} />;

    case 'Enterprise':
      return <EnterprisePlan {...data} isActive={isActive} />;

    default:
      return new Error(
        'Invalid plan type provided to renderPlan function inside Plan.tsx',
      );
  }
};

export const Plan: FC<Props> = ({ isActive = false, ...props }) => (
  <>{renderPlan(props as PlanResponse & PlanUsageResponse, isActive)}</>
);
